/** 寄件方式 */
export enum ShippingMethod {
  /** 直接郵寄 */
  DIRECT_MAIL = '0',
  /** 專人交付（限台灣本島） */
  DELIVERY_BY_HAND = '1'
}
